import React from 'react';
import { ContentLayout } from './styles';

const SectionLayout = ({ children, width, height, marginTop, paddingBottom, padding, border, paddingTop }) => {
  return (
    <ContentLayout
      width={width}
      height={height}
      marginTop={marginTop}
      paddingBottom={paddingBottom}
      paddingTop={paddingTop}
      padding={padding}
      border={border}
    >
      {children}
    </ContentLayout>
  );
};

export default SectionLayout;
